export default "__VITE_ASSET__CtTK5MEC__"